import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { CreateOrganizationForm } from '~/components/forms/OrganizationForm';
import { Heading } from '~/components/molecules/Heading';
import { useNavigate } from '~/components/utils/Navigation';

export type ICreateOrganizationPageProps = {
  nextUrl?: string;
  cancelUrl?: string;
};

export const CreateOrganizationPage: React.FC<ICreateOrganizationPageProps> = (
  props,
) => {
  const { nextUrl, cancelUrl } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>{t('CreateOrganizationPage.seo.title')}</title>
      </Helmet>

      <Heading
        title={t('CreateOrganizationPage.title')}
        subtitle={t('CreateOrganizationPage.subtitle')}
      />

      <CreateOrganizationForm
        onSuccess={(createdOrganization) =>
          navigate(nextUrl ?? `/organizations/${createdOrganization._id}`)
        }
        cancelUrl={cancelUrl ?? '/'}
      />
    </>
  );
};
